export default {
  $x年中报: '{{x}}/H1',
  $x年年报: '{{x}}/FY',
  '${x}季报（累计）': '{{x}} Quarterly Report (Cumulative)',
  '二季报(累计)': 'Q2(Cum.)',
  '三季报(累计)': 'Q3(Cum.)',
  减持$x: 'Reduced {{x}}',
  减持后剩余$x: '{{x}} remaining after reduce',
  增持$x: 'Increased {{x}}',
  增持后剩余$x: '{{x}} remaining after increase',
  $x年: '{{x}}',
  '每T+1结算': 'T+1 settlement',
  '每T+2结算': 'T+2 settlement',
  截至$x: 'as of {{x}}',
  $x更新: 'As of {{x}}',
  $x年$y季度: '20{{x}}Q{{y}}',
  $x年度: '{{x}}FY',
  '翻译中...': 'Translating...',
  更新时间: 'Updated',
  更新: 'Updated',
  股: 'shares',
  当日资金流向: 'Captital Distribution',
  盘口: 'Analysis',
  单位: 'Unit',
  净买入$1: 'Netflow',
  净买入$2: 'Net Buys',
  流入: 'Inflow',
  流出: 'Outflow',
  当日资金统计: 'Captital Netflow Trend',
  特大: 'Extra-Large',
  特大单: 'Extra-Large',
  大单: 'Large',
  中单: 'Medium',
  小单: 'Small',
  特大$1: 'XL',
  大单$1: 'L',
  中单$1: 'M',
  小单$1: 'S',
  资金流向说明: 'Introduction',
  资金流入: 'Net Inflow',
  资金流出: 'Net Outflow',
  '十大净买入/卖出经纪商': 'Top 10 Net B/S Brokers',
  最近5日主力增减仓: 'Large Order Trend in Last 5 Days',
  实时: 'Real-Time',
  近1日: 'Last Day',
  近5日: '5 Days',
  近20日: '20 Days',
  近60日: '60 Days',
  净卖出: 'Net sales',
  经纪商持股比例: 'Brokers Holding Ratio',
  实时数据: 'Real-Time Data',
  近N日数据: 'Data of last N Days',
  '净买入/净卖出：根据股票在当前交易日的逐笔明细和买卖盘经纪数据估算得出。':
    'Net Buys/Net Sales: estimated based on tick-by-tick details and order book brokerage data on the current trading day.',
  '净买入/净卖出：前1交易日的持股量减去再往前N个交易日的持股量。':
    'Net Buys/Net Sells: the shareholdings on the previous trading day minus the shareholdings before N trading days.',
  '经纪商持股比例=经纪商持仓股数/已发行股数':
    'Broker shareholding ratio = Number of shares held by brokers/Total Number of issued shares',
  '持股比例最高的几个经纪商，其持股比例的变化，一定程度能反映机构投资者对后市股价的态度。':
    'A high ratio indicates that institutional investors are optimistic about the stock market.',
  主力: 'Main Force',
  委托单: 'Orders',
  '主力由特大单和大单构成，关注主力的大单数据和资金流向能够更准备地了解行情趋势。':
    "The main force consists of extra-large orders and large orders. Paying attention to the main force's large order data and capital flow can more accurately understand the market trend.",
  '满足委托量、委托金额其中任何一个条件就认为是特大单、大单、中单、小单。':
    'If any one of the conditions of commission volume and amount is met, it will be considered as an extra-large order, large order, medium order or small order.',
  '小于等于前20个交易日（权证前3个交易日）的平均每笔成交量。':
    'Less than or equal the average turnover in the last 20 trading days(or last 3 trading days of warrants).',
  '大于前20个交易日平均每笔成交量小于等于10倍前20个交易日平均每笔成交量。':
    'More than the average turnover in the last 20 trading days and  less than 10 times  the average turnover in the last 20 trading days.',
  '大于10倍前20个交易日平均每笔成交量小于等于30倍前20个交易日平均每笔成交量。':
    'More than 10 times the average turnover  in the last 20 trading days and  less than 30 times  the average turnover in the last 20 trading days.',
  '大于30倍前20个交易日平均每笔成交量。':
    'Extra-Large Orders More than 30 times the average turnover in the last 20 trading days.',
  '注：前20个交易日与前3个交易日都不包含当天这个交易日。':
    'Note: The last 20 trading days and the last 3 trading days do not include today.',
  北京: 'BeiJing Time',
  万股: '10K',
  万亿: 'KB',
  港币: 'HKD',
  人民币: 'RMB',
  美元: 'USD',
  元: 'Yuan',
  亿: '100M',
  万: 'M/K',
  万港币: 'M/K HKD',
  万元: 'M/K Yuan',
  万美元: 'M/K USD',
  亿元: '100M Yuan',
  亿港币: '100M HKD',
  亿美元: '100M USD',
  数据截至: 'Data as of',
  净额: 'Netflow',
  正在努力加载: 'Loading',
  '正在努力加载...': 'Loading...',
  暂无数据: 'No Data',
  暂无更多内容: 'No Data',
  没有更多了: 'No Data',
  '- 暂无更多内容 -': 'No Data',
  查看更多: 'More Data',
  显示更多: 'More Data',
  查看更多$2: 'More Reports',
  研报评级: 'Analyst Ratings',
  买入: 'Buy',
  增持: 'Hold',
  中性: 'Neutral',
  减持: 'Reduce',
  卖出: 'Sell',
  '单位(家)': 'Com.Nums',
  '1年内': '1Y',
  '6月内': '6M',
  '3月内': '3M',
  '1月内': '1M',
  目标价预测: 'Target Price',
  预测最低价: 'Low',
  最低价: 'Low',
  重置: 'Reset',
  取消: 'Cancel',
  确认: 'Confirm',
  目标均价: 'Average',
  预测最高价: 'High',
  最高价: 'High',
  港元: 'HKD',
  最高: 'High ',
  均价: 'Average ',
  最低: 'Low ',
  昨收: 'Pre-close ',
  研报摘要: 'Summary',
  该内容为独立文件: 'This content is a separate file',
  打开文件: 'Open',
  公司简况: 'Summary',
  股东股本: 'Shareholder Equity',
  财务数据: 'Financials',
  主要指标: 'Key Indicators',
  市盈率: 'P/E',
  市净率: 'P/B',
  每股收益: 'EPS',
  每股净资产: 'BVPS',
  营业总收入: 'Revenue',
  营收同比: 'YOY',
  净利润同比: 'Net Income YOY',
  净利润: 'Net Income',
  公司资料: 'Company Profile',
  收入: 'Income',
  公司名称: 'Company',
  上市日期: 'Listing Date',
  '董事长（主席）': 'Chairman',
  董事长: 'Chairman',
  主席: 'Chairman',
  办公地址: 'Principal Place of Business',
  员工数量: 'Employees',
  公司官网: 'Website',
  主营业务: 'Business',
  按业务: 'Business',
  按地区: 'Region',
  公司高管: 'Company Executives',
  名字: 'Name',
  职务: 'Position',
  '持股数(万股)': 'Shares(10K)',
  高管持股变动: 'Executive Transactions',
  分红派息: 'Dividends',
  '免责声明：以上内容仅供参考，不作为投资决策依据。投资有风险，入市需谨慎。':
    'The content above is for reference only and should not be used as a basis for investment decisions.Market is volatile, invest with cautions.',
  股本结构: 'Equity Structure',
  总流通股本: 'Total Shares Outstanding',
  '普通股变动(股)': 'Change in Outstanding Shares(share)',
  变动日期: 'Date',
  '已发行普通股(股)': 'Shares Outstanding',
  '普通股变动(股)$2': 'Shares Chg',
  变动原因: 'Reason',
  主要股东: 'Major Holders',
  净利率: 'Net Margin',
  净利率$2: 'Net Porfit Ratio',
  净资产收益率: 'ROE',
  '净资产收益率(%)': 'ROE(%)',
  毛利率: 'Gross Margin',
  每股现金流: 'CFPS',
  资产负债率: 'DAR',
  总资产收益率: 'ROA',
  '总资产收益率(%)': 'ROA(%)',
  同比: 'YOY',
  全部: 'All',
  一季报: 'Q1',
  二季报: 'Q2',
  四季报: 'Q4',
  五季报: 'Q5',
  六季报: 'Q6',
  中报: 'H1',
  三季报: 'Q3',
  年报: 'FY',
  利润表: 'Income Statement',
  营业收入: 'Operating Revenue',
  '营业收入(营业额)': 'Operating Revenue',
  营业收入同比: 'Operating Revenue YOY',
  营业利润: 'Operating Income',
  营业利润同比: 'Operating Income YOY',
  资产负债表: 'Balance Sheet',
  总资产: 'Total Assets',
  总负债: 'Total Liabilities',
  股东权益合计: 'Total Equity',
  现金流量表: 'Cash Flow',
  经营净额: 'Net Operating Cash Flow',
  投资净额: 'Net Investing Cash Flow',
  融资净额: 'Net Financing Cash Flow',
  最新: 'Latest',
  年报$2: 'Annual',
  中报$2: 'Interim',
  报告期: 'Period of Report',
  归母净利润: 'Net Income  to Parent Company',
  每股指标: 'Per Share Indicator',
  每股指标$2: 'Per Share Indicators',
  每股收益$2: 'Basic Earnings Per Share',
  每股营业收入: 'Operating Income Per Share',
  盈利能力: 'Profitability',
  '毛利率(%)': 'Gross Porfit Ratio',
  '净利率(%)': 'Net Porfit Ratio',
  资本结构: 'Capital Structure',
  '资产负债率(%)': 'Debt to Assets Ratio',
  权益乘数: 'Equity Multipler',
  偿债能力: 'Solvency',
  关键指标: 'Key Indicator',
  流动比率: 'Current Ratio',
  速动比率: 'Quick Ratio',
  营运能力: 'Operating Capacity',
  '总资产周转率(%)': 'Total Assets Rate(T)',
  '总资产周转率(次)': 'Total Assets Rate(T)',
  成长能力: 'Growth Ability',
  '营收同比(%)': 'Operating Revenue YOY(%)',
  '净利润同比(%)': 'Net Income YOY(%)',
  公司秘书: 'Secretary',
  注册地: 'Registration',
  审计机构: 'Audit Institution',
  会计年结日: 'Fiscal Year Ends',
  所属市场: 'Market',
  公司邮箱: 'Email',
  公司简介: 'Company Profile',
  主营构成分析: 'Revenue Breakdown',
  合计: 'Total',
  展开全部: 'Expand All',
  展开: 'Expand',
  收起: 'Collapse',
  股东名称: 'Name',
  持股数量: 'Shares Held',
  持股比例: 'Ratio',
  变动数量: 'Shares Chg',
  变动股数: 'Shares Chg',
  发布日期: 'Position Date',
  公告日期: 'Report Date',
  分配方案: 'Allocation Plan',
  股权登记日: 'Record Date',
  除净日: 'Ex-Date',
  派息日: 'Pay Date',
  回购: 'Buybacks',
  回购日期: 'Buyback Date',
  回购均价: 'Avg.Price',
  回购数量: 'BuybackQty',
  回购金额: 'BuybackAmt',
  '/总成交': '/Total Shares',
  自普通决议案通过后: 'Total Buyback Qty',
  '股份回购数总量(股数)': 'Since the resolution(Shrs)',
  '股份回购数总量(%)': 'Since the resolution(%)',
  拆股并股: 'Stock Splits',
  报告日期: 'Date',
  方式: 'Type',
  比例: 'Ratio',
  除净日$2: 'Ex-Rights Day',
  最新递表: 'Delivered',
  认购中: 'Subscribing',
  '待上市(暗盘)': 'To be Listed',
  已上市: 'Listed',
  公司名称$2: 'Company Name',
  申请状态: 'Status',
  申请日期: 'Date',
  板块: 'Sector',
  招股书: 'Prospectus',
  认购: 'Subscription',
  入场费: 'Min Amount',
  招股价: 'Issue Price',
  认购截止时间: 'Deadline',
  公布中签: 'Announce Results',
  未开始: 'To be Announced',
  定价: 'Issue Price',
  暗盘时间: 'Grey Market Trading',
  名称代码: 'Symbol',
  发行价: 'Initial Price',
  首日涨跌幅: '1st-day %Chg',
  首日一手: '1st-day',
  最高盈利: 'Highest Profit',
  累计涨跌幅: 'Accum %Chg',
  总市值: 'Mkt Cap',
  年龄: 'Age',
  入职日期: 'Appointment Date',
  加载中: 'Loading',
  正在加载: 'Loading',
  '附件正在加载中...': 'PDF is loading',
  点击翻译: 'Tap to Translate',
  基本资料: 'Overview',
  ETF全称: 'ETF Name',
  资产净值: 'NAV',
  发行股本: 'Shares',
  '资产规模(香港)': 'AUM(HK)',
  资产规模: 'AUM',
  追踪指数: 'Benchmark',
  费用占比: 'Ongoing charges',
  发行商: 'Issuer',
  托管人: 'Custodian',
  基金经理: 'Fund Manager',
  上市时间: 'Listing Date',
  派息政策: 'Dividend Policy',
  投资风格: 'Investment Style',
  资产类别: 'Asset class',
  投资地区: 'Region',
  业绩表现: 'Performance',
  历史业绩: 'Historic Performance',
  历史净值: 'Historic NAV',
  基金持仓: 'Holdings',
  基金持仓$2: 'Fund Holdings',
  资产: 'Share Class',
  资产$2: 'Assets',
  行业: 'Industrial',
  重仓股票: 'Top Holdings',
  股票名称: 'Name',
  持仓数量: 'Shares Held',
  持仓占比: '%  Positions',
  变动: 'Chg %',
  基金规模: 'AUM',
  基金规模$2: 'AUM Change',
  分红拆分: 'Dividends & Splits',
  阶段收益: 'Cumulative',
  季度收益: 'Quarterly',
  年度收益: 'Annual',
  周期: 'Period',
  涨跌幅: 'Chg %',
  成立日: 'Inception date',
  净值: 'NAV',
  日涨幅: 'Latest',
  净资产: 'Net Assets',
  拆股并股$2: 'Splits',
  拆分折算日: 'Ex-Rights Day',
  拆分比例: 'Ratio',
  '拆分前/后净值': 'NAV before/after Split',
  开始认购: 'Start',
  截止认购: 'Subscribe by',
  公布中签$2: 'Results Out',
  暗盘: 'Grey Mkt',
  上市: 'IPO',
  发行概况: 'IPO Information',
  资讯: 'News',
  财务: 'Financials',
  简况: 'Summary',
  融资: 'Margin',
  基本信息: 'Basic Information',
  每手股数: 'Shares Per Lot',
  发行数量: 'Shares Offered',
  日期: 'Date',
  销售费用: 'Selling Expenses',
  '- 销售费用': '- Selling Expenses',

  // 利润表
  营业成本: 'Cost of Revenue',
  毛利润: 'Gross Profit',
  营业毛利: 'Gross Profit',
  行政支出: 'Administrative Expenses',
  行政开支: 'Administrative Expenses',
  研发费用: 'Research & Development Expenses',
  其他营业支出: 'Other Operating Expense',
  营业支出总额: 'Operating Expense',
  核心利润: 'Income From Continuous Operations',
  其他收入: 'Other Income',
  其他非经营项目: 'Other Non-operating Items',
  营业利润$2: 'Operating profit',
  财务成本: 'Finance Costs',
  联营合营公司: 'Share of Results of Asso. & JCEs',
  税前利润: 'Earning before tax',
  税项: 'Tax',
  '净利润(税后)': 'Earning after tax',
  少数股东权益: 'Minority profit',
  股东应占溢利: 'Net Income to Common shareholders',
  其他全面收入: 'Other comprehensive income',
  全面收入总额: 'Total comprehensive income',
  每股基本盈利: 'Basic EPS',
  每股摊薄盈利: 'Diluted EPS',
  普通股股息: 'Common Shares Dividends',
  '经调整每股派息(港元)': 'Adj Dividend Per Share(HKD)',
  '物业、机器及设备折旧': 'Depreciation',
  无形资产摊销: 'Amortization Expense',
  折旧及摊销: 'Depreciation & Amortization Expense',
  '税率(%)': 'Tax Rate',
  '覆盖时期(月)': 'Coverage Period (months)',
  报表种类: 'Financial Report Type',
  报表货币: 'Currency',
  '净资产收益率(ROE)': 'ROE',
  '资产收益率(ROA)': 'ROA',
  财报每股基本盈利: 'Basic EPS',
  财报每股摊薄盈利: 'Diluted EPS',
  财报每股派息: 'Dividend Per Share',
  利息收益: 'Interest Income',
  利息支出: 'Interest Expense',
  利息收益净额: 'Net Interest Income',
  费用收益: 'Service Income',
  费用支出: 'Service Charge',
  费用收益净额: 'Net Service Income',
  交易收益净额: 'Net Income on Financial Instruments at Fair Value',
  保险收入净额: 'Net premium income',
  其他营业收益: 'Other Operating Income',
  营业收益总额: 'Operating Revenue',
  保险索偿净额: 'Net Insurance Claims and Policy Liabilities',
  未扣除贷款减值及其他准备之营业收益净额: 'Operating Profit before Deducting Impairment',
  贷款减值及信贷风险准备: 'Impairment and Provisions',
  营业收益净额: 'Operating Profit after Deducting Impairment',
  经营开支总额: 'Operating Expenses',
  营业毛利率: 'Gross Porfit Ratio',
  共同控制公司及联营公司: 'Share of Results of Asso. & JCEs',
  除税前溢利: 'Earning before Tax',
  本期间溢利: 'Earning after Tax',
  本公司股本持有人应占: 'Net Income to Common Shareholders',
  非控股权益: 'Minority Profit',
  '净利润(纯利)': 'Net Porfit',
  经营费用: 'Operating Expense',
  营业费用: 'Operating Expense',
  销售和管理费用: 'Selling and Administrative Expenses',
  '- 管理费用': '- Administrative Expenses',
  减值及拨备: 'Impairment and Provisions',
  净非营业利息收入: 'Net Non Operating Interest Income Expense',
  利息收入: 'Interest Income',
  其他非经营收入: 'Other Non-operating Income',
  所得税: 'Tax',
  权益性投资收益: 'Investment Income',
  净利润$2: 'Net Income',
  持续经营利润: 'Income from Continuous Operations',
  归属于少数股东的净利润: 'Minority Profit',
  归属于母公司的净利润: 'Net Income to Parent Company',
  其他优先股派息: 'Preferred Dividends',
  归属于普通股股东的净利润: 'Net Income to Common Shareholders',
  综合收益总额: 'Total Comprehensive Income',
  其他综合收益: 'Other Comprehensive Income',
  '- 归属于少数股东的全面收益': '- Minority Comprehensive Income',
  '- 归属于母公司股东的全面收益': '- Comprehensive Income to Parent Company',
  基本每股收益: 'Basic EPS',
  稀释每股收益: 'Diluted EPS',
  货币单位: 'Currency',
  会计准则: 'Accounting Standards',
  年结日: 'Fiscal Year Ends',
  公布日期: 'Pub Date',
  报告截止日: 'End Date',
  '基本每股收益-普通股': 'Basic EPS-Common Share',
  '稀释每股收益-普通股': 'Diluted EPS-Common Share',
  '每股股息-普通股': 'Dividend Per Share-Common Share',
  毛承保费及保单费收入: 'Total premium income',
  分出保费: 'Premium',
  净承保费及保单费收入: 'Net premium income',
  未到期责任准备金变动: 'Unearned premium reserve',
  已赚取保费及保费单收入净额: 'Realized Net Premium Income',
  净投资收益: 'Investment Income',
  净保费及投资收益总额: 'Net Premium Income and Investment Income',
  '已实现及未实现的投资收益/(亏损)': 'Realized and Unrealized Investment Income',
  '汇兑收益/(亏损)': 'Exchange Gains and Losses',
  佣金支出净额: 'Commission and Handling Fee Expenses',
  行政及其他费用: 'Administration Expenses',
  保险业务支出及其他费用: 'Total Payment、Claims and Expenses',

  // 经纪商持股详情
  持股比例与收盘价走势: 'Shareholdings Variation',
  收盘价: 'Prev Close',
  持股量变动: 'Net Buys',
  详细数据: 'Change Details',
  持股日期: 'Date',
  价格: 'Price',
  持股量: 'Shareholding',

  //现金流量表
  经营活动: 'Cash Flows-Operating Activities',
  持续经营净收入: 'Net Income From Continuing Operations',
  折旧及摊销$2: 'Depreciation & Amortization',
  基于股票的补偿费: 'Stock-Based Compensation',
  递延所得税: 'Deferred Taxes',
  资产处置损益: 'Assets Disposal Gain or Loss',
  投资损益: 'Investment Gain or Loss',
  汇兑损益: 'Exchange Gain or Loss',
  权益性投资损益: 'Equity Investment Gain or Loss',
  经营业务调整其他项目: 'Other Operations Adjustment',
  应收账款及票据: 'Accounts Receivable and Notes',
  应收关联方款项: 'Receivable Relevantor',
  存货变化: 'Changes in Inventories',
  预付费用: 'Prepaid Expenses',
  应付关联方款项: 'Payable Relevantor',
  应付账款及票据: 'Accounts Payable and Notes',
  应付税项: 'Tax Payable',
  预提费用及其他负债: 'Accrued Expenses and Other Liabilities',
  经营业务其他项目: 'Other Operating Activities',
  其他流动资产: 'Other Current Assets',
  经营活动产生的现金流量净额: 'Net Cash Flow-Operating',
  投资活动: 'Cash Flows-Investing Activities',
  '存款增加(减少)': 'Deposits Increase (decrease)',
  购买固定资产: 'Purchase of Fixed Assets',
  处置固定资产: 'Disposal of Fixed Assets',
  购建无形资产及其他资产: 'Purchase of Intangible Assets and Other Assets',
  处置无形资产及其他资产: 'Disposal of Intangible Assets and Other Assets',
  投资支付现金: 'Cash from Investing',
  债务偿还: 'Debt Repaid',
  投资业务其他项目: 'Other Investing Activities',
  投资活动产生的现金流量净额: 'Net Cash Flows-Investing',
  筹资活动: 'Cash Flows-Financing Activities',
  发行股份: 'Stock Issued',
  发行债券: 'Debt Issued',
  股息支付: 'Stock Dividends Paid',
  行使股票期权所得: 'Proceeds From Stocks and Options',
  新增借款: 'New Borrowings',
  '现金及权益增加(减少)': 'Cash and Equity Increase (decrease)',
  '垫款增加(减少)': 'Advances Increase (decrease)',
  偿还借款: 'Borrowings Repaid',
  贷款收益: 'Proceeds From Loans',
  发行费用相关: 'Relevant Issuance Fees',
  票据相关收益: 'Proceeds From Notes',
  筹资业务其他项目: 'Other Financing Activities',
  筹资活动产生的现金流量净额: 'Net Cash Flows-Financing',
  汇率变动影响: 'Effect of Exchange Rate',
  现金流净增加额: 'Change In Cash Flow',
  期初现金流: 'Cash Flow-Beginning of Year',
  期末现金流: 'Cash Flow-End of Year',
  自由现金流: 'Free Cash Flow',
  经营业务之现金流量: 'Cash Flows-Operating Activities',
  出售固定资产: 'Disposal of Fixed Assets',
  经营业务产生之现金净额: 'Net Cash Flow-Operating',
  已收利息: 'Interest Received',
  已收股息: 'Dividend Received',
  投资回报及融资费用之现金流量: 'Cash Flows From Investing and Financial Charges',
  增添固定资产: 'Fixed Assets Increase',
  投资增加: 'Investment Increase',
  投资减少: 'Investment Decrease',
  投资业务产生之现金净额: 'Net Cash Flows-Investing',
  融资业务产生之现金净额: 'Net Cash Flows-Financing',
  已付利息: 'Interest Paid',
  已派股息: 'Dividend Paid',
  新增贷款: 'Debt Increase',
  偿还贷款: 'Debt Repaid',
  股本融资: 'Equity Financing',
  '其他(投资回报)': 'Other Investing Activities',
  '退回/(已缴)税项': 'Refund/paid tax',
  '定息/债项工具融资': 'Fixed Interest/Debt Instruments Financing',
  '关连人士现金流量(投资活动)': 'Cash Flows from Related Parties (Investing Activities)',
  '其他(投资活动)': 'Other Investing Activities',
  '关连人士现金流量(融资活动)': 'Cash Flows from Related Parties (Financing Activities)',
  '偿还定息/债项工具': 'Repayment of Fixed Interest/Debt Instruments',
  '其他(融资活动)': 'Other Financing Activities',
  '已发行股本变动(股)': 'Change In Issued Stock',
  发放现金股利: 'Pay Cash Dividends',
  年终之现金及等同现金项目: 'Cash and Cash Equivalents -End of Year',
  年初之现金及等同现金项目: 'Cash and Cash Equivalents -Beginning of Year',
  '现金及等同现金之增加/(减少)净额': 'Net Cash and Cash Equivalents Increase(Decrease)',
  '外币汇率变动之影响/其他': 'Effect of Exchange Rate',
  经营活动现金流量: 'Cash Flows-Operating Activities',
  投资活动现金流量: 'Cash Flows-Investing Activities',
  融资活动现金流量: 'Cash Flows-Financing Activities',
  非金融: 'Non-Financial',
  银行: 'Bank',
  保险: 'Insurance',
  无派息: 'Non-Dividend',
  // 资产负债表
  流动资产: 'Current Assets',
  现金及现金等价物和短期投资: 'Cash and Cash Equivalents & Short-Term Investments',
  '- 现金和现金等价物': '- Cash and Cash Equivalents',
  '- 短期投资': '- Short-Term Investments',
  受限制现金: 'Restricted Cash',
  流动资产合计: 'Total Current Assets',
  非流动资产: 'Non-Current Assets',
  固定资产净额: 'Fixed Assets',
  商誉及其他无形资产: 'Goodwill & Other Intangible Assets',
  '- 商誉': '- Goodwill',
  '- 其他无形资产': '- Other Intangible Assets',
  投资和预付款: 'Investments and Advances',
  长期预付费用: 'Long-Term Prepaid Expenses',
  非流动资产合计: 'Total Non-Current Assets',
  流动负债: 'Current Liabilities',
  应付账款: 'Accounts Payable',
  '- 应付税费': '- Tax Payable',
  应计费用: 'Accrued Expenses',
  短期借款与租赁负债: 'Short-Term Debt And Lease Obligation',
  '递延负债(流动)': 'Deferred Liability(Non-Current)',
  '- 客户存款及垫款': '- Deposits and Advances to Customer',
  '- 递延收入(流动)': '- Deferred Revenue(Current)',
  流动负债总额: 'Total Current Liabilities',
  非流动负债: 'Non-Current Liabilities',
  长期借款与租赁负债: 'Long-Term Debt And Lease Obligation',
  '递延负债(非流动)': 'Deferred Liabilities',
  '- 递延所得税负债(非流动)': '- Deferred Taxes Liabilities',
  '- 递延收入(非流动)': '- Deferred Revenue(Non-Current)',
  其他非流动负债: 'Other Non-Current Liabilities',
  非流动负债总额: 'Total Non-Current Liabilities',
  总负债$2: 'Total Liabilities',
  所有者权益: 'Stock Holders Equity',
  股本: 'Equity',
  '- 普通股股本': '- Common Equity',
  '- 优先股': '- Preferred Equity',
  留存收益: 'Retained Earnings',
  其他储备: 'Other Reserves',
  资本公积: 'Capital Surplus',
  库存股: 'Treasury Stock',
  归属于母公司股东权益其他项目: 'Parent company Equity-Other Projects',
  归属于母公司股东权益: 'Parent company Equity',
  少数股东权益$2: 'Minority Interest',
  负债和股东权益合计: 'Total Liabilities & Equity',
  总权益: 'Total Equity',
  固定资产: 'Fixed Assets',
  投资: 'Investments',
  商誉及无形资产: 'Goodwill & Intangible Assets',
  其他非流动资产: 'Other Non-Current Assets',
  非流动资产总额: 'Total Non-Current Assets',
  存货: 'Inventory',
  贸易应收款项: 'Trading Receivable',
  现金及银行结存: 'Cash and Bank Balances',
  流动资产总额: 'Total Current Assets',
  资产净值$2: 'Net Assets',
  营运资金: 'Operations Assets',
  营运资金变动: 'Change In Operations Assets',
  现金总额: 'Total Cash',
  '净现金/(债项)': 'Net Cash/Debt',
  '定期存放银行同业及其他财务机构(资产)': 'Regular Deposits Due to Banks and Other Financial Institutions(Assets)',
  '衍生工具(资产)': 'Derivatives(Assets)',
  库存现金及短期资金: 'Treasury Cash and Short-Term Assets',
  向其他银行托收中之项目: 'Collecting Items From Other Banks',
  商业票据: 'Commercial Paper',
  交易用途资产: 'Transaction Purpose Assets',
  非交易用途资产: 'Non-Transaction Purpose Assets',
  公平订值之金融资产: 'Fairly Valued Financial Assets',
  可供出售之证券: 'Securities Saleable',
  存款证: 'Certificate of Deposit',
  银行同业贷款及垫款: 'Deposits and Advances Due to Banks',
  客户贷款及垫款: 'Deposits and Advances to Customer',
  金融投资: 'Financial Investment',
  持至到期投资: 'Held-to-Maturity Investment',
  联营及合资公司权益: 'Equity of Associated Companies and Joint Ventures',
  '房屋，产房及设备': 'Gross Property,Plant & Equipment',
  '预付土地/租赁款项': 'Prepaid Land/Lease Payments',
  投资物业: 'Investment Property',
  租赁土地权益: 'Equity In Leasehold Land',
  债权类证券: 'Debt Securities',
  股权类证券: 'Equity Securities',
  衍生金融资产: 'Derivative Financial Sssets',
  贷款: 'Loans',
  其他投资: 'Other Investments',
  联营公司权益: 'Equity of Associated Companies',
  共同控制公司权益: 'Equity of Joint Ventures',
  商誉: 'Goodwill',
  其他无形资产: 'Other Intangible Assets',
  应收保险款项: 'Premium Receivable',
  分保资产: 'Reinsurance Assets',
  应收关连公司款项: 'Receivable From Associated Company',
  贸易应付款项: 'Trading Payable',
  短期债项: 'Short-Term Debt',
  其他短期负债: 'Other Short-Term Debt',
  '流动资产/(负债)净值': 'Net Current Assets/Liabilities',
  总资产减流动负债: 'Total Asets Minus Current Liabilities',
  长期债项: 'Long-Term Debt',
  总债项: 'Total Debt',
  速动资产: 'Quick Assets',
  资产负债率$2: 'Debt to Assets Ratio',
  股本总额: 'Total Stock Capital',
  储备总额: 'Total Reserves',
  本公司拥有人应占权益: 'Company Owner Equity',
  永久资本证券: 'NePermanent Capital Securitiess',
  非控股权益$2: 'Non-Controlling Equity',
  权益总额: 'Total Equity',
  其他资产: 'Other Assets',
  香港纸币流通额: 'Aggregates of Hong Kong Paper Currency',
  同业及财务机构存款: 'Deposits Due to Banks and Financial Institutions',
  客户存款: 'Deposits  to Customer',
  负债: 'Liabilities',
  '定期存放银行同业及其他财务机构(负债)': 'Regular Deposits Due to Banks and Other Financial Institutions(Liabilities)',
  '衍生工具(负债)': 'Derivatives(Liabilities)',
  已发行之债务证券: 'Issued Debt Securities',
  已发行之存款证: 'Issued Certificate of Deposit',
  已发行之可换股债券: 'Issued Convertible bonds',
  已发行之浮息票据: 'Issued Floating Rate Note',
  交易用途负债: 'Transaction Purpose Liabilities',
  公平订值之金融负债: 'Fairly Valued Financial Liabilities',
  后偿负债: 'Subordinated Liabilities',
  其他负债: 'Other Liabilities',
  资本储备: 'Capital Reserve',
  递延保单获取成本变动: 'Deferred Policy Acquisition Costs',
  递延税项资产: 'Deferred Taxes Assets',
  法定存款: 'Legal Deposit Reserve',
  保险准备金: 'Insurance Reserves',
  保险保障基金: 'Insurance Protection Fond',
  应付保险款项: 'Premium Payable',
  保户投资合同负债: 'Insured Investment Contract Liabilities',
  卖出回购资产: 'Assets Sold for Repurchase',
  衍生金融负债: 'Derivative Financial Liabilities',
  应付关连公司款项: 'Payable From Associated Company',
  应付所得税: 'Income Tax Payable',
  递延税项负债: 'Deferred Taxes Liabilities',
  保单持有人权益: 'Policyholder Equity',
  现金及现金等价物: 'Cash and Cash Equivalents',
  股东权益: "Shareholders' Equity",
  股东权益$2: 'Equity',
  '房屋,产房及设备': 'Gross Property,Plant & Equipment',
  // 新股详情
  新闻: 'News',
  新闻详情: 'News',
  轮证列表: 'Warrants Lists',
  '简况(F10)': 'Summary',
  中信国际: 'CSBHK',
  公告: 'Filings',
  研报: 'Reports',
  基石名称: 'Name',
  基石投资者: 'Cornerstone Investor',
  认购股数: 'Actual Subs. Quantity',
  认购占比: 'Subs. Proportion',
  解禁日: 'Lock-up Expiry Date',
  保荐人: 'Sponsor',
  名称: 'Name',
  类别: 'Category',
  承销商: 'Underwriter',
  融资概览: 'Overview',
  $y更新: 'Updated:{{y}}',
  $x倍: '{{x}}',
  融资认购倍数: 'Margin Times',
  融资认购额: 'Margin Amount',
  '融资额(公开)': 'Net Proceeds',
  券商融资认购: 'Brokerage Statistics',
  券商融资额: 'Brokerage Margin Amount',
  融资认购状态: 'Margin Development',
  '融资认购倍数/融资认购额': 'Margin Times/Margin Amount',
  '本页面数据内容来源于捷利交易宝，中信只做汇总展示，仅供参考，不构成任何形式的投资建议。因使用数据而导致的一切损失，请自行负责。新股的最终认购数据，以港交所披露的配售结果为准。':
    'The data on this page comes from Jieli Tradego. CITIC provides summary display for reference only and does not constitute any investment advice.Please take your own responsibility for all losses caused by using data.The final subscription data for IPOs shall be subject to the results disclosured by HKEx.',
  新股日历: 'IPO Calendar',
  新股名称: 'Company Name',
  最小: 'Min',
  认购金额: 'Amount',
  认购$2: 'Subscribe',
  资金冻结: 'Frozen Funds',
  暗盘$2: 'Grey Market',
  '免责声明：以上内容信息仅供参考，不构成任何邀约、邀请、招揽、建议买卖认合产品的依据，在您做出任何投资决策前，请根据自身情况考虑投资产品相关的风险因素。港股新股有破发风险，请您谨慎考虑后参与新股认购。股市有风险，投资须谨慎':
    'Disclaimer: The information above  is for reference only and does not constitute a basis for any invitation, solicitation, or recommendation to invest any product.Before you make any investment decisions, please consider the risk based on your own circumstances. There is a risk of fall on debut in Hong Kong stocks Mkt.Please consider carefully before Stagging. Market is volatile, invest with cautions.',
  // 轮证
  '名称/代码': 'Name/Symbol',
  最新价: 'Price',
  现价: 'Price',
  行使价: 'Strike',
  相关股票: 'Related Stocks',
  净流入: 'Net Inflow',
  分红送转: 'Dividends/Splits',

  下限价: 'Low Limit',
  上限价: 'High Limit',
  涨跌额: 'Chg',
  员工人数: 'Employees',
  占比: 'Proportion',
  小于: 'Less than',
  '该股票自上市以来无股本变动。': 'There are no change in outstanding shares since the stock listing.',
  股本变动: 'Shares Chg',
  主要股东持股变动: 'Chg of Major Holders',
  主要股东持股: 'Major Holders',
  毛利率$2: 'Gross Porfit Ratio',
  营业利润率: 'Gross Porfit Ratio',
  EBITDA利润率: 'EBITDA Margin',
  研发费用率: 'R&D Expense Ratio',
  销售费用率: 'Selling Expense Ratio',
  管理费用率: 'Administration Expense Ratio',
  '净资产收益率-摊薄': 'ROE-Diluted',
  总资产净利率: 'ROA',
  息税前营业利润率: 'EBIT Margin',
  长期负债股东权益比率: 'Long-Term Debt to Equity Ratio',
  产权比率: ' Debt Equity Ratio',
  利息倍数: 'Interest Coverage',
  总资产周转天数: 'Total Assets Turnover Days',
  每股收益TTM: 'EPS',
  同比上涨: 'YOY increased',
  货币: 'Currency',
  已申请: 'Subscribed',
  通过聆讯: 'Hearing Completed',
  正在处理: 'Processing',
  查看: 'Details',
  无暗盘: 'No Grey Mkt',
  美东: 'ET',
  所属板块: 'Concept',
  未知机构: 'Unknown Broker',
  昨日: 'Prev',
  近1周: '1W',
  近1月: '1M',
  近3月: '3M',
  近6月: '6M',
  近9月: '9M',
  近1年: '1Y',
  近2年: '2Y',
  近3年: '3Y',
  近4年: '4Y',
  近5年: '5Y',
  今年以来: 'YTD',
  成立以来: 'ITD',
  净资产变动: 'NAV Chg',
  持有人变动: 'Shareholders Chg',
  总份额: 'Shares',
  机构: 'Institutions',
  个人: 'Insider',
  其他: 'Other',
  '文件不存在!': 'File does not exist!',
  '无权限!': 'No permission!',
  港股新股: 'HK IPOs',
  成交量: 'Volume',
  成交额: 'Turnover',
  到期日: 'To Exp',
  街货比: 'Street%',
  行权价: 'Strike Price',
  街货量: 'StreetVol',
  买量: 'Bid Vol',
  卖量: 'Ask Vol',
  溢价: 'Premium',
  '价内/价外': 'Price In/Out',
  引申波幅: 'IV',
  对冲值: 'Delta',
  收回价: 'Call Price',
  距收回价: 'To Call Price',
  有效杠杆: 'Eff Gearing',
  杠杆比率: 'Gearing',
  换股比率: 'ER',
  状态: 'Status',
  终止交易: 'Recalled',
  正常: 'Normal',
  待上市: 'To be Listed',
  认购证: 'Call',
  认沽证: 'Put',
  牛证: 'Bull',
  熊证: 'Bear',
  界内证: 'Inline',
  发行人: 'Issuer',
  到期日$2: 'To Expiration',
  '<3个月': 'Below 3M',
  '3-6个月': '3-6M',
  '6-12个月': '6-12M',
  '>12个月': 'Over 12M',
  价内: 'ITM',
  价外: 'OTM',
  '<1倍': 'Below 1x',
  '<30%': 'Below 30%',
  '1-5倍': '1-5x',
  '5-10倍': '5-10x',
  '>10倍': 'Over 10x',
  '>70%': 'Over 70%',
  筛选: 'Filter',
  类型: 'Type',
  街货比$2: 'Outstanding Ratio',
  比例变化: 'Ratio Chg',
  持股变动: 'Net Buys',
  暗盘交易中: 'Grey Market Trading',
  标题: 'Title',
  报表截止日: 'End Date',
  每股经营现金流: 'Operating Cash Flow Per Share',
  '一季报(单季)': 'Q1(Quarterly)',
  '二季报(单季)': 'Q2(Quarterly)',
  '三季报(单季)': 'Q3(Quarterly)',
  '四季报(单季)': 'Q4(Quarterly)',
  上市前报: 'Pre-IPO',
  投资目标: 'Objective',
  流通股本: 'Shares',
  机构持股: 'Institutional Holdings',
  成分股: 'Holdings',
  持股种类: 'Shareholder Type',
  持仓类型: 'Position type',
  本次持仓变动: 'Current position change',
  变动后剩余: 'Remaining after change ',
  机构持股汇总: 'Institutions',
  '持股家数(家)': 'Number of Shareholders',
  '持股总数(股)': 'Shares Held',
  '持股市值(元)': 'Shares Value',
  '占总股本比例(%)': '%Owned',
  '持仓变化(股)': 'Shares Chg',
  事件进度: 'Event Process',
  '股价(元)': 'Price',
  新股认购: 'IPOs',
  新股详情: 'IPO Information',
  公告详情: 'Filings',
  研报详情: 'Reports',
  公司行动: 'Events',
  高管及持股变动: 'Executives & Transactions',
  轮证: 'Warrants',
  经纪商持股详情: 'Brokers Holding Details',
  经纪商持股比例说明: 'Introduction',
  '十大净买入/卖出经纪商说明': 'Introduction',
  代码: 'Symbol',
  持有数量: 'Shares Held',
  确认事项: 'Confirmations',
  '阁下于申请认购公开发售股份前，请确认以下各点：':
    'Before you apply to subscribe for public offer shares, please confirm the following points:',
  '阁下在作出投资决定前，已获提供充足的机会接触及阅读公开发售之发售章程及其他要约文件。':
    'You have been provided with ample opportunities to access and read the offering prospectus and other offer documents of the public offering before making an investment decision.',
  '并且在作出投设决定时，已依据有关公开发售之发售章程及其他要约文件的内容而非其他资料。':
    'And when making investment decisions, the contents of the offering prospectus and other offer documents related to the public offering have been relied on rather than other information.',
  '特别是不应该依据宣传或推广材料及传媒报导。 阁下已经阅读及同意公开发售之发售章程所载的条款及条件。':
    'In particular, publicity or promotional materials and media reports should not be relied upon. You have read and agreed to the terms and conditions set out in the Offering Prospectus of the Public Offering.',
  '阁下已经阅读并同意受本行「证券买卖协议」及上述之条款所管限。':
    'You have read and agree to be bound by our [Securities Trading Agreement] and the above terms.',
  '阁下确认阁下符合资格申请认购首次公开发售发行人的证券。':
    'You confirm that you are eligible to apply to subscribe for the securities of the IPO issuer.',

  // 融脉AI智投
  '总结完成，以下是我提取的核心信息': "Summary done.Here are the core information I've extracted",
  开始: 'start',
  融脉AI智投: 'Rongmai AI',
  免责声明: 'Disclaimer',
  '免责声明：以上内容仅供参考，不作为投资依据':
    'Disclaimer: The above content is for reference only and should not be used as a basis for investment',
  '投资有风险，入市需谨慎': 'Investing involves risks, proceed with caution',
  扣非净利润: 'Deducted Non Net Profit',
  每股资本公积金: 'Capital Reserve per Share',
  每股未分配利润: 'Undistributed Profit per Share',
  存货周转率: 'Inventory Turnover Ratio',
  总资产周转率: 'Total Asset Turnover Ratio',
  应收账款周转天数: 'Accounts Receivable Turnover Days',
  营业收入同比增长率: 'YOY Operating Income',
  净利润同比增长率: 'YOY Net Profit',
  管理人: 'Manager',
  发行方: 'Issuer',
  发行时间: 'IssueTime',
  分配频率: 'Allocation Freq.',
  东京: 'Tokyo',
  年薪: 'Salary',
  任职日期: 'Appointment Date',
  学历: 'Education',
  请输入数字: 'Please enter a number',
  ETF名称: 'ETF Name',
  日股ETF: 'JP-ETF',
  '星期一~日': 'Mon~Sun',
  上交所: 'SH Ex',
  深交所: 'SZ Ex',
  东证: 'JP Ex',
  更新日期: 'Update',
  '数量（股）': 'Shrs',
  金额: 'Amount',
  总股本: 'Total Shrs',
  变动比例: 'Chg-Ratio',
  费用比率: 'Expense Ratio',
  '{}张 ': '',
  '{X}股  {Y}手 {Z}港币': '{X}Shrs（{Y}Lots）{Z}HKD',
  'A 股发行前股本': 'Pre-issuance Share Capital of A-shares',
  '非公开增发 A 股': 'Private Placement of A-shares',
  送转股: 'Bonus Share Issue',
  激励期权行权: 'Exercise of Incentive Options',
  可转换债券转股: 'Conversion of Convertible Bonds',
  股份回购后注销: 'Share Cancellation After Repurchase',
  'A 股上市': 'A-share Listing',
  'A 股发行法人配售上市': 'Allotment Listing of Legal Persons in A-share Issuance',
  三板上市: 'Listing on the Third Board',
  配股上市: 'Rights Issue Listing',
  '增发 A 股上市': 'Additional A-share Listing',
  '增发 A 股法人配售上市': 'Allotment Listing of Legal Persons in Additional A-share Issuance',
  股权分置方案实施: 'Implementation of Split Share Structure Reform',
  股权分置股份追送: 'Additional Shares in Split Share Structure Reform',
  股权分置限售流通: 'Restricted Circulation of Shares in Split Share Structure Reform',
  股权转让: 'Equity Transfer',
  股权激励限售流通: 'Restricted Circulation of Shares from Equity Incentives',
  发行前股份限售流通: 'Restricted Circulation of Pre-issuance Shares',
  无限售不减持承诺到期: 'Expiration of No-Sale Commitment for Unlimited-Sale Shares',
  '股份性质变动-无限售承诺不减持': 'Change in Share Nature - No-Sale Commitment for Unlimited-Sale Shares',
  挂牌交易: 'Listing and Trading',
  增发变动: 'Changes from Additional Issuance',
  增发股份限售流通: 'Restricted Circulation of Additional Issuance Shares',
  发行人持股限售流通: 'Restricted Circulation of Shares Held by Issuers',
  股东增持变动: 'Changes in Shareholding Increase by Shareholders'
}
